class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  connectedCallback() {
    this.init();
  }

  init() {
    //this.activateFirstFilter(); // Activate the first filter when the unique filter is active
  }

  activateFirstFilter() {
    const uniqueFilter = this.closest('.facets-unique-filter');
    if (uniqueFilter) {
      const firstFilter = this.querySelector('.facets__label');
      if (firstFilter) {
        firstFilter.click();
      }
    }
  }

  static removeFilterDuplicate() {
    const filterToRemoveSelector = document.querySelector('[data-filter-to-remove-selector]');
    if (filterToRemoveSelector) {
      const filterToRemove = document.querySelector(filterToRemoveSelector.dataset.filterToRemoveSelector);
      filterToRemove.remove();
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      const selectorUniqueFilter = section.selectorUniqueFilter ? section.selectorUniqueFilter : null;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, selectorUniqueFilter)
        : FacetFiltersForm.renderSectionFromFetch(url, event, selectorUniqueFilter);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event, selectorUniqueFilter) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event, selectorUniqueFilter);
        if (!selectorUniqueFilter) {
          FacetFiltersForm.renderProductGridContainer(html);
          FacetFiltersForm.renderProductCount(html);
          FacetFiltersForm.renderFiltersCount(html);
          FacetFiltersForm.renderFiltersCountSecondary(html);
        }
        
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);        
        document.querySelector('#MainContent').click(); // Prevent the hover mode that stays on ios
      });
  }

  static renderSectionFromCache(filterDataUrl, event, selectorUniqueFilter) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event, selectorUniqueFilter);
    if(!selectorUniqueFilter){
      FacetFiltersForm.renderProductGridContainer(html);
      FacetFiltersForm.renderProductCount(html);
      FacetFiltersForm.renderFiltersCount(html);
      FacetFiltersForm.renderFiltersCountSecondary(html);
    }
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);    
    document.querySelector('#MainContent').click(); // Prevent the hover mode that stays on ios
  }

  static renderFiltersCount(html) {
    document.querySelector('.facets-container:not(.facets-unique-filter) #FacetsFiltersCount').outerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector('.facets-container:not(.facets-unique-filter) #FacetsFiltersCount').outerHTML;
  }

  static renderFiltersCountSecondary(html) {
    document.querySelector('.facets-container:not(.facets-unique-filter) #FacetsFiltersCountSecondary').outerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector('.facets-container:not(.facets-unique-filter) #FacetsFiltersCountSecondary').outerHTML;
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const countEl = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    if (!countEl) return;

    const count = countEl.innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container:not(.facets-unique-filter) .facets-container .loading__spinner, .facets-container:not(.facets-unique-filter) facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event, selectorUniqueFilter) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    if(selectorUniqueFilter){
      const uniqueFilterElementToRender = document.querySelector('.facets-unique-filter .facets__display');

      uniqueFilterElementToRender.innerHTML = parsedHTML.querySelector(selectorUniqueFilter).innerHTML;
    }
    else{
      // const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
    //   '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    // );
    // const facetDetailsElementsFromDom = document.querySelectorAll(
    //   '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    // );
      const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
        '.facets-container:not(.facets-unique-filter) #FacetFiltersForm .js-filter, .facets-container:not(.facets-unique-filter) #FacetFiltersFormMobile .js-filter, .facets-container:not(.facets-unique-filter) #FacetFiltersPillsForm .js-filter'
      );
      const facetDetailsElementsFromDom = document.querySelectorAll(
        '.facets-container:not(.facets-unique-filter) #FacetFiltersForm .js-filter, .facets-container:not(.facets-unique-filter) #FacetFiltersFormMobile .js-filter, .facets-container:not(.facets-unique-filter) #FacetFiltersPillsForm .js-filter'
      );

      // Remove facets that are no longer returned from the server
      Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
        if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
          currentElement.remove();
        }
      });

      const matchesId = (element) => {
        const jsFilter = event ? event.target.closest('.js-filter') : undefined;
        return jsFilter ? element.id === jsFilter.id : false;
      };
      const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
      const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

      facetsToRender.forEach((elementToRender, index) => {
        const currentElement = document.getElementById(elementToRender.id);
        // Element already rendered in the DOM so just update the innerHTML
        if (currentElement) {
          document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
        } else {
          if (index > 0) {
            const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
            // Same facet type (eg horizontal/vertical or drawer/mobile)
            if (elementToRender.className === previousElementClassName) {
              document.getElementById(previousElementId).after(elementToRender);
              return;
            }
          }

          if (elementToRender.parentElement.id) {
            document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
          }
        }
      });

      FacetFiltersForm.renderActiveFacets(parsedHTML);
      FacetFiltersForm.renderAdditionalElements(parsedHTML);

      if (countsToRender) {
        const closestJSFilterID = event.target.closest('.js-filter').id;

        if (closestJSFilterID) {
          FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
          FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

          const newFacetDetailsElement = document.getElementById(closestJSFilterID);
          const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
            ? `.mobile-facets__close-button`
            : `.facets__summary`;
          const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
          if (newElementToActivate) newElementToActivate.focus();
        }
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.facets-container:not(.facets-unique-filter) .active-facets-mobile', '.facets-container:not(.facets-unique-filter) .active-facets-desktop', '.facets-container:not(.facets-unique-filter) .active-facets-mobile-from-modal'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });
    if (document.getElementById('FacetFiltersFormMobile')) {
      document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
    }
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
      {
        section: document.getElementById('subCollectionsWrapper').dataset.id,
        selectorUniqueFilter: '.facets__display'
      }
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const filterActive = event.target.closest('.visual-display-parent.active');
    const uniqueFilterActive = filterActive?.closest('.facets-unique-filter');
    if (uniqueFilterActive) {
      this.onActiveUniqueFilterClick(event);
      return;
    }

    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }

  onActiveUniqueFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const removeUrl = event.target.closest('.facets__label').dataset.removeUrl;
    const url =
      removeUrl.indexOf('?') == -1
        ? ''
        : removeUrl.slice(removeUrl.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);


/* Mobile Facets */
class FacetFiltersFormMobile extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.filterLabelContainers = this.querySelectorAll('.filter-label--container');
    this.closeFilterValuesButtons = this.querySelectorAll('.filter-value--close');
    this.facetsOverlay = document.querySelector('.facets-overlay');
    this.sortByOptions = this.querySelectorAll('.sort-by-values input[type="radio"]');
    this.closeFiltersValues = this.closeFiltersValues.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 0);

    this.querySelector('form').addEventListener('input[type="checkbox"]', this.debouncedOnSubmit.bind(this));

  }

  connectedCallback() {
    this.filterLabelContainers.forEach((filter) => {
      filter.addEventListener('click', (event) => this.openFilterValues(event));
    });
    this.closeFilterValuesButtons.forEach((button) => {
      button.addEventListener('click', (event) => this.closeFilterValues(event));
    });
    this.facetsOverlay.addEventListener('click', this.closeFiltersValues);
    this.sortByOptions.forEach((option) => {
      option.addEventListener('change', this.debouncedOnSubmit.bind(this));
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersFormMobile.searchParamsInitial;
      if (searchParams === FacetFiltersFormMobile.searchParamsPrev) return;
      FacetFiltersFormMobile.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  openFilterValues(event) {
    const index = event.target.dataset.index;
    const filterValuesContainer = this.querySelector(`#filter-value--${index}`);
    filterValuesContainer.classList.add('filter-values--container--active');
    this.facetsOverlay.style.display = "block";
    if (document.querySelector('#tidio-chat-iframe')) {
      document.querySelector('#tidio-chat-iframe').style.display = "none";
    }
  }
  closeFilterValues(event) {
    const index = event.target.dataset.index;
    const filterValuesContainer = this.querySelector(`#filter-value--${index}`);
    filterValuesContainer.classList.remove('filter-values--container--active');
    this.facetsOverlay.style.display = "none";
    if (document.querySelector('#tidio-chat-iframe')) {
      document.querySelector('#tidio-chat-iframe').style.display = "block";
    }
  }
  closeFiltersValues() {
    const filtersValuesContainer = this.querySelectorAll(`.filter-values--container`);
    filtersValuesContainer.forEach((filterValuesContainer) => {
      filterValuesContainer.classList.remove('filter-values--container--active');
    });
    this.facetsOverlay.style.display = "none";
    if (document.querySelector('#tidio-chat-iframe')) {
      document.querySelector('#tidio-chat-iframe').style.display = "block";
    }
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersFormMobile.searchParamsPrev = searchParams;
    const sections = FacetFiltersFormMobile.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersFormMobile.filterData.some(filterDataUrl) ?
        FacetFiltersFormMobile.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersFormMobile.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersFormMobile.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersFormMobile.filterData = [...FacetFiltersFormMobile.filterData, { html, url }];
        FacetFiltersFormMobile.renderFilters(html, event);
        FacetFiltersFormMobile.renderProductGridContainer(html);
        FacetFiltersFormMobile.renderProductCount(html);
        location.reload();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersFormMobile.filterData.find(filterDataUrl).html;
    FacetFiltersFormMobile.renderFilters(html, event);
    FacetFiltersFormMobile.renderProductGridContainer(html);
    FacetFiltersFormMobile.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersFormMobile .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersFormMobile.renderActiveFacets(parsedHTML);
    FacetFiltersFormMobile.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersFormMobile.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersFormMobile.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });
    if (document.getElementById('FacetFiltersFormMobile')) {
      document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
    }
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersFormMobile.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersFormMobile.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersFormMobile.renderPage(url);
  }
}

FacetFiltersFormMobile.filterData = [];
FacetFiltersFormMobile.searchParamsInitial = window.location.search.slice(1);
FacetFiltersFormMobile.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form-mobile', FacetFiltersFormMobile);
FacetFiltersFormMobile.setListeners();
FacetFiltersForm.removeFilterDuplicate();